import { render, staticRenderFns } from "./EntityDetailsMap.vue?vue&type=template&id=8b89a6ca&"
import script from "./EntityDetailsMap.vue?vue&type=script&lang=js&"
export * from "./EntityDetailsMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports